import axios from 'axios';

export const getWebsiteOwnershipConfig = async () => {
  const { data } = await axios.get('/api/website-ownership/config');
  return data;
};

export const saveWebsiteOwnershipConfig = async (config) => {
  const { data } = await axios.put('/api/website-ownership/config', config);
  return data;
};
